import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { DUPLICATE_NOTE_SUCCESS } from "~/store/action_types/index.jsx";
import { duplicateNote } from "~/store/actions/actions.notes.jsx";
import { getNoteById } from "~/store/selectors/selector.notes.jsx";
import { DuplicateObjectDialog } from "../DuplicateObjectDialog/DuplicateObjectDialog.jsx";
import { showSuccessToast } from "../Toast/index.js";

const NoteDuplicateDialog = ({ open, noteId, projectId, onCancel, onSubmit }) => {
  const dispatch = useDispatch();
  const note = useSelector((state) => getNoteById(state, noteId));

  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleDuplicate = useCallback(
    ({ name }) => {
      if (typeof onSubmit === "function") {
        onSubmit();
      }
      dispatch(
        duplicateNote(projectId, noteId, {
          new_name: name,
          project_id: projectId,
          note_id: noteId,
        })
      ).then((action) => {
        if (action.type === DUPLICATE_NOTE_SUCCESS) {
          showSuccessToast(t("Note duplicated"));

          const { response = {} } = action;
          const { result = {} } = response;

          const { single = 0 } = result;

          if (single > 0) {
            navigate(`/projects/${projectId}/notes/${single}`);
          }
        }
      });
    },
    [onSubmit, dispatch, projectId, noteId, t, navigate]
  );

  return (
    <DuplicateObjectDialog
      open={open}
      name={note?.name}
      title={t("Duplicate Note")}
      labelText={t("Note name")}
      explainerText={t("All note properties, including subscribers will be copied to the new note.")}
      onSubmit={handleDuplicate}
      onCancel={onCancel}
    />
  );
};

NoteDuplicateDialog.propTypes = {
  open: PropTypes.bool,
  noteId: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

NoteDuplicateDialog.defaultProps = {
  open: false,
};

export default NoteDuplicateDialog;
